document.addEventListener('DOMContentLoaded', () => {
  Fancybox.bind("[data-fancybox-single]", {
    Carousel: false,   
    Thumbs: false,     
    dragToClose: false,
    Toolbar: {
      display: {
        left: [],
        middle: [],
        right: ["close"]
      }
    },
    keyboard: {
      ArrowLeft: false,
      ArrowRight: false,
      Escape: "close"
    }
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//     if (typeof lucide !== 'undefined') {
//         lucide.createIcons();
//     }

//     const tooltipContainers = document.querySelectorAll('.tooltip-container');

//     tooltipContainers.forEach(container => {
//         const hotspotBtn = container.querySelector('.hotspot-button');
//         const tooltipContent = container.querySelector('.tooltip-content');

//         hotspotBtn.addEventListener('click', (e) => {
//             e.stopPropagation();
//             tooltipContent.classList.toggle('show');
//         });

//         document.addEventListener('click', (event) => {
//             if (!container.contains(event.target)) {
//                 tooltipContent.classList.remove('show');
//             }
//         });
//     });
// })

document.addEventListener("DOMContentLoaded", function () {
    if (typeof lucide !== 'undefined') {
        lucide.createIcons();
    }

    const tooltipContainers = document.querySelectorAll('.tooltip-container');

    tooltipContainers.forEach(container => {
        const hotspotBtn = container.querySelector('.hotspot-button');
        const tooltipContent = container.querySelector('.tooltip-content');

        hotspotBtn.addEventListener('click', (e) => {
            e.stopPropagation();

            tooltipContainers.forEach(other => {
                if (other !== container) {
                    other.querySelector('.tooltip-content').classList.remove('show');
                }
            });

            tooltipContent.classList.toggle('show');
        });

        document.addEventListener('click', (event) => {
            if (!container.contains(event.target)) {
                tooltipContent.classList.remove('show');
            }
        });
    });
});



document.addEventListener("DOMContentLoaded", function () {
    function faqsAccordion() {
        var accordionSections = document.querySelectorAll(".accordion-item");

        if (accordionSections.length > 0) {
            var firstAccordionItemHeader = accordionSections[0].querySelector(
                ".accordion-item-header"
            );
            var firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;

            if (firstAccordionItemBody) {
                firstAccordionItemHeader.classList.add("active");
                firstAccordionItemBody.style.maxHeight =
                    firstAccordionItemBody.scrollHeight + "px";
            }

            for (let i = 1; i < accordionSections.length; i++) {
                var otherHeader = accordionSections[i].querySelector(".accordion-item-header");
                var otherBody = otherHeader.nextElementSibling;

                if (otherBody) {
                    otherHeader.classList.remove("active");
                    otherBody.style.maxHeight = "0";
                }
            }
        }

        accordionSections.forEach((section) => {
            var accordionItemHeaders = section.querySelector(".accordion-item-header");
            var accordionItemBody = section.querySelector(".accordion-item-body");

            accordionItemHeaders.addEventListener("click", function () {
                var currentlyActiveHeader = document.querySelector(
                    ".accordion-item-header.active"
                );
                var currentlyActiveBody = currentlyActiveHeader
                    ? currentlyActiveHeader.nextElementSibling
                    : null;

                if (currentlyActiveHeader && currentlyActiveBody) {
                    currentlyActiveHeader.classList.remove("active");
                    currentlyActiveBody.style.maxHeight = 0;
                }

                if (accordionItemHeaders !== currentlyActiveHeader) {
                    accordionItemHeaders.classList.add("active");
                    accordionItemBody.style.maxHeight =
                        accordionItemBody.scrollHeight + "px";
                } else {
                    accordionItemHeaders.classList.remove("active");
                    accordionItemBody.style.maxHeight = 0;
                }
            });
        });
    }

    faqsAccordion();
});

document.addEventListener("DOMContentLoaded", () => {
    const allVideos = document.querySelectorAll(".prodReviewBoxCard");

    allVideos.forEach(card => {
        const video = card.querySelector("video");
        const playBtn = card.querySelector(".prodRevPlayBtn");

        playBtn.addEventListener("click", () => {
            document.querySelectorAll(".prodReviewBoxCard video").forEach(v => {
                if (v !== video) {
                    v.pause();
                    v.parentElement.parentElement.classList.remove("playing");
                }
            });

            video.play();
            card.classList.add("playing");
        });

        video.addEventListener("click", () => {
            video.pause();
            card.classList.remove("playing");
        });

        video.addEventListener("ended", () => {
            card.classList.remove("playing");
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const wrapper = document.querySelector('.appstle_subscription_wrapper');
    const description = document.querySelector('.appstleSellingPlanDescription');

    if (wrapper && description && description.parentElement !== wrapper) {
      wrapper.appendChild(description);
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});



// New js Animation
{
document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger),
      gsap.utils.toArray(".anim-Y-img").forEach((element) => {
        const isMobile = window.innerWidth <= 767;
        gsap.fromTo(
          element,
          { scale: 1.2 },
          {
            scale: 1,
            ease: "none",
            scrollTrigger: {
              trigger: element,
              start: "top 90%",
              end: isMobile ? "top 50%" : "top 30%",
              scrub: 1,
            },
          }
        );
      });
  });

}
// New js Animation